import { emsToDisplay } from '../../../services/utils/DateFormat';
import userSettingsEngine from '../../../controllers/UserSettings/UserSettingsEngine';

export const OUTPUT_MSG_TYPES = ['log', 'warning', 'error', 'action'];
export const DEFAULT_OUTPUT_MSG_TYPE = 'log';

export const OUTPUT_MSG_TYPE_COLORS = {
    log: 'var(--jx-muted)',
    warning: '#e0a640',
    error: '#e05a4a',
    action: '#4a8abf',
};

/**
 * Formats just the "HH:mm:ss cat :" prefix (no message text) — split out so
 * OutputMsgRow can render it as its own copyable segment, separate from the
 * pipe-delimited parts of msg.text.
 * @param {{timestamp: number, cat: string}} msg
 * @returns {string}
 */
export function formatMsgPrefix(msg) {
    const fmt = userSettingsEngine.resolve('msgWindow.dateTimeFormat');
    const time = emsToDisplay(msg.timestamp, fmt);
    return `${time} ${msg.cat} :`;
}

/**
 * Formats a single message as a plain-text line: "HH:mm:ss cat : message".
 * Time format comes from msgWindow.dateTimeFormat (moment.js tokens, own
 * setting — independent of contentPanel.chipDateTimeFormat).
 * Shared by OutputMsgRow (display) and OutputMsgDlg (Copy All / per-row copy).
 * @param {{timestamp: number, cat: string, text: string}} msg
 * @returns {string}
 */
export function formatMsgLine(msg) {
    return `${formatMsgPrefix(msg)} ${msg.text}`;
}
